import axios from 'axios';

import { api } from '../../../firebase';
import { Activities, throttleControl } from '../../../util/throttler';

export function copyElementsRequest(args) {
  throttleControl(Activities.AddRoomKit, () => axios.post(`${api}/room/copyElements`, args).then(({ data }) => data));
}
